module.exports = __webpack_public_path__ + "static/media/test5_1.bc478d39.png";